import React from 'react'

import ClearIcon from '@mui/icons-material/Clear'
import DoneIcon from '@mui/icons-material/Done'
import { IconButton } from '@mui/material'

import { useToggleMatchSelected } from 'hooks/useMatch'

type CampaignTargetsMatchButtonProps = {
  id: string
  selected: boolean
}

const CampaignTargetsMatchButton = ({ id, selected }: CampaignTargetsMatchButtonProps) => {
  const toggleSelected = useToggleMatchSelected()

  return (
    <IconButton
      aria-label={selected ? 'Deselect' : 'Select'}
      onClick={() => toggleSelected(id, !selected)}
      size="large">
      {selected ? <DoneIcon /> : <ClearIcon />}
    </IconButton>
  )
}

export default CampaignTargetsMatchButton
